<template lang="pug">
.v-section-slider.section-slider(v-if="slider")
	v-loader(:loading="loading")
	template(v-if="template === 'ad'")
		.section-slider__title--ad(v-if="slider.title" ) {{ slider.title }}
	.section-slider__arrow.section-slider__arrow--prev(ref="prev")
		v-svg-icon.section-slider__arrow-icon(icon="slide-left")
	.section-slider__arrow.section-slider__arrow--next(ref="next")
		v-svg-icon.section-slider__arrow-icon(icon="slide-right")
	v-swiper-slider(v-if="slider && slider.items && slider.items.length"
		:options="options"
		:navigation="navigation"
		:pagination="pagination"
		@swiper="onSwiper")
		swiper-slide.section-slider__slide(v-for="(card, index) in slider.items" :key="index")
			template(v-if="template === 'projects'")
				.page-section-projects__card.card.fldc
					template(v-if="card.link" )
						a.card__link(
							:href="card.link?.href"
							:target="card.link?.target")
					template(v-if="card.image" )
						img.card__img(
							:src="card.image?.src"
							:alt="card.image?.alt")
					.card__label(v-if="card.label" ) {{ card.label }}
					.card__title(v-if="card.title" ) {{ card.title }}
					.card__subtitle(v-if="card.subtitle" ) {{ card.subtitle }}
					.card__separator
					.card__footer(v-if="card.footer" )
						template(v-if="card.footer.image" )
							img.card__company-logo(
								:src="card.footer.image?.src"
								:alt="card.footer.image?.alt")
						.card__company-name(v-if="card.footer.title" ) {{ card.footer.title }}
			template(v-if="template === 'property'" )
				.card-property
					template(v-if="card.link" )
						a.card__link(
							:href="card.link?.href"
							:target="card.link?.target")
					template(v-if="card.image" )
						img.card__img.card-property__img(
							:src="card.image?.src"
							:alt="card.image?.alt")
					.card__label--light(v-if="card.label" ) {{ card.label }}
					.card-property__item
						.card-property__head
							.card-property__price(v-if="card.price")
								v-price.card-property__price-current(:price="card.price")
									//span.card-property__price-currency(v-if="card.price.current.currency") {{ card.price.current.currency }}&nbsp;
									//span.card-property__price-value(v-if="card.price.current.value") {{ formatInteger(card.price.current.value) }}
							.card-property__id(v-if="card.id" ) ID:{{ card.id }}
						.card-property__title(v-if="card.title" ) {{ card.title }}
						.card-property__location(v-if="card.location" )
							span.card-property__region(v-if="card.location.region" ) {{ card.location.region }},&nbsp;
							span.card-property__district(v-if="card.location.district" ) {{ card.location.district }}
						.card__logo(v-if="card.logo" )
							img.card__company-logo(
								:src="card.logo?.src"
								:alt="card.logo?.alt")
			template(v-if="template === 'specialist'")
				.card-mini
					a.card-mini__wrap(:href="card?.href || '#'")
						template(v-if="card.image" )
							img.card-mini__image(
								:src="card.image?.src"
								:alt="card.image?.alt")
						.card-mini__title(v-if="card.title" ) {{ card.title }}
						.card-mini__subtitle(v-if="card.subtitle")  {{ card.subtitle?.text }}
			template(v-if="template === 'ad'")
				.card-advrtsmnt
					a.card-advrtsmnt__link(v-if="card.link" :href="card.link?.href")
						img.card-advrtsmnt__logo(v-if="card.logo"
							:src="card.logo?.src"
							:alt="card.logo?.alt")
						img.card-advrtsmnt__img(v-if="card.image"
							:src="card.image?.src"
							:alt="card.image?.alt")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';
import breakpoints from '../scripts/breakpoints.js';
import uniqueId from '../scripts/helpers/uniqueId.js';
import {SwiperSlide} from "swiper/vue";

export default {
	components: {
		SwiperSlide
	},

	mixins: [
		sourceMixin,
		formattingMixin
	],

	props: {
		template: {
			type: String,
			default: 'projects'
		},

		options: {
			type: Object,
			default: {
				slidesPerView: 4,
				spaceBetween: 20,
				breakpoints: {
					[breakpoints['md-min']]: {
						slidesPerView: 4
					},
					[breakpoints['xs-min']]: {
						slidesPerView: 2
					},
					[breakpoints['4xs-min']]: {
						slidesPerView: 1
					}
				}
			}
		}
	},

	data() {
		return {
			slider: {},
			uniqueId: uniqueId('swiper-'),
			navigation: false,
			pagination: {
				dynamicBullets: true,
			},
		};
	},

	methods: {
		dataSet(data) {
			this.slider = data;
		},

		onSwiper() {
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},
	}
};
</script>